import { render } from "./FormEditorView.vue?vue&type=template&id=0cb6ae8c"
import script from "./FormEditorView.vue?vue&type=script&lang=js"
export * from "./FormEditorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__